<template>
  <div class="relative inline-block text-left" ref="menu">
    <div>
      <button @click="toggleMenu" type="button" class="bg-transparent rounded-full hover:bg-gray-200 p-2 transition-colors">
          <svg class="w-6 h-6" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z" stroke="black" stroke-width="2.16667" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z" stroke="black" stroke-width="2.16667" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z" stroke="black" stroke-width="2.16667" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
      </button>
    </div>

    <div v-if="isOpen" class="absolute bottom-full right-10 mt-2 w-32 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5">
      <div class="py-1" role="menu" aria-orientation="vertical" aria-labelledby="options-menu">
          <Link
              v-for="link in links" :key="link.href" :href="!link.disabled ? link.href : '#'"
              :class="['block px-4 py-2 text-sm font-bold', link.disabled ? 'text-gray-400 cursor-not-allowed' : 'text-gray-700 hover:bg-gray-100']"
              :aria-disabled="link.disabled || false"
              role="menuitem"
          >
              {{ link.text }}
          </Link>
      </div>
    </div>
  </div>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3'

export default {
    components: { Link },
  props: {
    links: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data() {
    return {
      isOpen: false
    };
  },
  methods: {
    toggleMenu() {
      this.isOpen = !this.isOpen;
    },
    handleClickOutside(event) {
      if (this.$refs.menu && !this.$refs.menu.contains(event.target)) {
        this.isOpen = false;
      }
    }
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleClickOutside);
  }
};
</script>
